import { isAxiosError } from 'axios'
import loungeBoardAxios from '../../app/loungeBoardAxios'
import { createApi } from '@reduxjs/toolkit/query/react'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../../features/loungeBoard/loungeBoardContants'

const axiosBaseQuery = () => async urlOrConfig => {
  try {
    const response = await (typeof urlOrConfig === 'string'
      ? loungeBoardAxios.get(urlOrConfig)
      : loungeBoardAxios.request(urlOrConfig))
    // http status code가 200인 에러 처리
    if (response.data?.code !== '0000') {
      return Promise.reject({
        code: response.data.code,
        message: response.data?.message,
      })
    }
    return { data: response?.data }
  } catch (axiosError) {
    console.error(axiosError)
    return {
      error: isAxiosError(axiosError)
        ? {
            status: axiosError.response?.status,
            data: axiosError.response?.data,
          }
        : {},
    }
  }
}

export const loungeBoardApi = createApi({
  reducerPath: 'loungeBoardApi',
  tagTypes: ['UncheckedCount', 'List', 'Banner'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getUncheckedNoticeCount: builder.query({
      query: () => '/api/public/bulletin/uncheckedCount',
      providesTags: () => [{ type: 'UncheckedCount' }],
    }),
    getNoticeList: builder.query({
      query: () => ({
        method: 'GET',
        url: '/api/public/bulletin/list',
        params: {
          includePreview: 'true',
        },
      }),
      providesTags: () => [{ type: 'List' }],
    }),
    getNoticeBanner: builder.query({
      query: () => '/api/public/bulletin/banner',
      providesTags: () => [{ type: 'Banner' }],
    }),
    postNoticeCheck: builder.mutation({
      query: () => ({
        method: 'POST',
        url: '/api/public/bulletin/check',
        data: { serviceType: LOUNGE_BOARD_SERVICE_TYPE },
      }),
      invalidatesTags: () => [{ type: 'UncheckedCount' }],
    }),
  }),
})
export const {
  useGetUncheckedNoticeCountQuery,
  useGetNoticeListQuery,
  useGetNoticeBannerQuery,
  usePostNoticeCheckMutation,
} = loungeBoardApi
